import { BarChart2 } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgReports = mkIcon(BarChart2);